import { InitializeAddOrgFunctionsRequestSchema, InitializeAddOrgFunctionsResponseSchema } from './initialize-add-org-functions.schema';
/**
 * Initialize Add OrgFunctions Contract
 * POST /api/v2/initialize/org-functions
 * Bulk create Funktionen and Teams with email-resolved leads/memberships.
 */ export const InitializeAddOrgFunctionsContract = {
    method: 'POST',
    path: '/api/v2/initialize/org-functions',
    description: 'Bulk create Funktionen and Teams during initial setup',
    requestSchema: InitializeAddOrgFunctionsRequestSchema,
    responseSchema: InitializeAddOrgFunctionsResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Invalid request body, unresolved emails, or prerequisites missing',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - insufficient permissions'
        }
    }
};

//# sourceMappingURL=initialize-add-org-functions.contract.js.map